import * as CryptoJS from 'crypto-js';
/**
 * @param {string} clientSecret 与后端 client-secret 一致
 * @param {string} requestUri   与后端 request-uri 配置完全一致
 * @param {string} nonce        建议 UUID，与请求头 X-Nonce 一致
 */
export function buildMqttOpenSignature(clientSecret: string, requestUri: string, nonce: string) {
    const timestamp = `${Date.now()}`; // 毫秒
    const signString = ['GET', requestUri, '', timestamp, nonce.trim()].join('|');
    const sig = CryptoJS.HmacSHA256(signString, CryptoJS.enc.Utf8.parse(clientSecret));
    return {
        timestamp,
        signature: CryptoJS.enc.Hex.stringify(sig), // 小写 hex
        nonce: nonce.trim(),
    };
}

export function buildMqttOpenHeaders(clientSecret: string, requestUri: string, nonce: string) {
    const { timestamp, signature, nonce: n } = buildMqttOpenSignature(clientSecret, requestUri, nonce);
    return {
        'X-Timestamp': timestamp,
        'X-Signature': signature,
        'X-Nonce': n,
    };
}

/**
 * @param {string} cipherBase64   响应 data
 * @param {string} aesKeyBase64   与后端 aes-key 一致（Base64）
 */
export function decryptEmqxCredentialsData(cipherBase64: string, aesKeyBase64: string) {
    const key = CryptoJS.enc.Base64.parse(aesKeyBase64);
    const decrypted = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Base64.parse(cipherBase64) }, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
}
